import React from 'react';
import clsx from 'clsx';

import './index.scss';
import SpPopUp from 'components/molecules/SpPopUp';

const SpConfItem = ({ 
  text, 
  children, 
  questionMark,
  popUpTitle,
  popUpDetail, 
}) => {

  const DispTitle = () => {
    return Array.isArray(text)
      ? text.map(line => (
        <span key={line} className="">
          {line}
          <br />
        </span>
      ))
      : <>{text}</>;
  };

  const DispChildren = () =>{
    return Array.isArray(children)
      ? children.map(line => (
        <span key={line.label} className="">
          {line.label}
          <br />
        </span>
      ))
      : <>{children}</>;
  };
  return (
    <div className="SpConfItem">
      <div className="title-wrapper">
        <div className="title">
          <DispTitle />
          <span 
            className={clsx('QuestionMarkIcon',
              { qShow: questionMark === false })}
          >
            <SpPopUp title={popUpTitle}>{popUpDetail}</SpPopUp>
          </span>
        </div>
      </div>
      <div className="itemArea">
        <p className="">
          <DispChildren />
        </p>
      </div>
    </div>
  );
};

export default SpConfItem;